/* src/app/service-distributor/distributor-business-details/distributor-business-details.component.scss */
.formly-field {
  margin-bottom: 10px;
}
.p-col-12 {
  margin-bottom: 0.4em;
}
.p-button {
  margin-top: 1em;
}
::ng-deep .ng-invalid.ng-touched {
  border-color: darkred !important;
  box-shadow: none !important;
}
::ng-deep label {
  color: var(--Gray-700, #344054);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  margin-bottom: 4px;
}
::ng-deep .p-dropdown {
  margin-top: 8px;
  margin-bottom: 4px;
}
::ng-deep input {
  margin-top: 8px;
  margin-bottom: 4px;
}
::ng-deep .formly-validation-message {
  margin-top: 4px;
  color: #e24c4c;
  font-weight: bold;
}
form {
  width: 672px;
}
::ng-deep .p-button-icon-only {
  background: transparent !important;
  border: none !important;
  color: #F04438 !important;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
::ng-deep .p-button-icon-only:hover {
  color: #F04438 !important;
}
::ng-deep .Addbutton {
  background-color: #fff;
  border: none !important;
  color: #D47500;
  padding: 0px;
  margin-top: 20px;
  gap: 8px;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  box-shadow: none;
}
::ng-deep .Addbutton:focus {
  box-shadow: none;
}
::ng-deep .p-button-label {
  flex: none;
}
::ng-deep p {
  font-size: 14px;
  color: #475467;
  margin: 0px;
  margin-top: 2px;
}
::ng-deep h3 {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: #101828;
  margin: 0;
}
::ng-deep .BAddress {
  margin-top: 28px;
}
/*# sourceMappingURL=distributor-business-details.component-MZ3YA455.css.map */
